import { useMemo } from 'react';

export interface FormSubmitReadinessOptions {
    formLoading: boolean;
    /** Sözleşme listesi henüz yüklenmediyse true */
    agreementsLoading?: boolean;
    captchaLoading?: boolean;
}

export function useFormSubmitReadiness(options: FormSubmitReadinessOptions) {
    const { formLoading, agreementsLoading = false, captchaLoading = false } = options;

    return useMemo(() => {
        const canSubmit = !formLoading && !agreementsLoading && !captchaLoading;
        return {
            canSubmit,
            formLoading,
            agreementsLoading,
            captchaLoading,
        };
    }, [formLoading, agreementsLoading, captchaLoading]);
}
